import { render } from "./createInvoice.vue?vue&type=template&id=1a93129b"
import script from "./createInvoice.vue?vue&type=script&lang=js"
export * from "./createInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__